import { format, parseISO } from 'date-fns';

import ScreenLoader from '@/component/ScreenLoader';
import { HomeOwner } from '@/component/HomeOwner';
import { LatestNews } from '@/component/Blogs';
import { Item } from './Item';

export const BlogItem = ({ slug, blog, item, hideBack, hideBlog }) => {
  const date =
    item?.createdAt && format(parseISO(item?.createdAt), 'MMMM dd, yyyy');

  return (
    <>
      {!item ? (
        <ScreenLoader />
      ) : (
        <div className="page-wrapper page-blog 3xl:space-y-3">
          <div className="container 3xl:rounded-10">
            <Item
              title={item?.title}
              headline={item?.headline}
              coverImage={item?.coverImage}
              content={item?.content}
              hideBack={hideBack}
              hideBlog={hideBlog}
              date={date}
              author={item?.author}
              slug={slug}
            />
          </div>
          <HomeOwner />
          <LatestNews />
        </div>
      )}
    </>
  );
};
